export default __webpack_public_path__ + "static/media/falken.b50adf0e.png";